import {
  GET_NAUSEARCH_ITEM,
  GET_NAUSEARCH_ITEM_FAILED,
  REQUEST_PDF,
  REQUEST_PDF_FAILED,
  REQUEST_RUBRIC,
  REQUEST_RUBRIC_FAILED,
  REQUEST_SEARCH_DETAILS_RESULTS,
  REQUEST_SEARCH_DETAILS_RESULTS_FAILED,
  REQUEST_SEARCH_RESULTS,
  REQUEST_SEARCH_RESULTS_FAILED,
} from '../constants/index';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
  requestPdfSuccess,
  requestRubricSuccess,
  requestSearchDetailsSuccess,
  requestSearchResultsSuccess,
} from '../actions/searchActions';
import axios from 'axios';
import config from '../../shared/config';
import { getNauSearchItemSuccess } from '../actions/searchItemActions';
import safeFetch from '../../shared/api/safeFetch';

function* requestSearchResultsHandler(action) {
  const { query, mode } = action.payload;
  const isBrowserOnline = yield select((state) => state.user.isBrowserOnline);

  if (!isBrowserOnline) {
    const searchResults = yield select((state) => state.search.searchResults);
    const searchText = yield select((state) => state.search.searchValue);
    const isSearchText = searchText && !!searchText.trim();
    const filteredResults = isSearchText
      ? searchResults.filter((item) => {
          return (item.title && item.title.includes(searchText)) || (item.data && item.data.includes(searchText));
        })
      : searchResults;
    yield put(requestSearchResultsSuccess({ data: filteredResults, isBrowserOnline: false, mode }));
    return;
  }

  try {
    const { data } = yield call(safeFetch, `${config.searchUrl}/query`, {
      body: query,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });

    yield put(requestSearchResultsSuccess({ data, mode }));
  } catch (error) {
    yield put({
      message: (error.response && error.response.status) || error.message,
      type: REQUEST_SEARCH_RESULTS_FAILED,
    });
  }
}

function* requestRubricHandler(action) {
  const { cls, lang } = action.payload;
  try {
    const { data } = yield call(safeFetch, `${config.apiUrl}/cls/all?cls=${cls}&lang=${lang}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });

    yield put(requestRubricSuccess({ cls, data }));
  } catch (error) {
    yield put({
      message: error.response,
      type: REQUEST_RUBRIC_FAILED,
    });
  }
}

function* getNauSearchItemHandler(action) {
  const id = action.payload;
  try {
    const { data } = yield call(safeFetch, `${config.apiUrl}/publication/uref/${id}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });

    yield put(getNauSearchItemSuccess(data));
  } catch (error) {
    yield put({
      message: error.response,
      type: GET_NAUSEARCH_ITEM_FAILED,
    });
  }
}

function* requestSearchDetailsResultsHandler(action) {
  try {
    const { data } = yield call(safeFetch, `${config.searchUrl}/query`, {
      body: action.payload,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });

    yield put(requestSearchDetailsSuccess(data));
  } catch (error) {
    yield put({
      message: (error.response && error.response.status) || error.message,
      type: REQUEST_SEARCH_DETAILS_RESULTS_FAILED,
    });
  }
}

function* requestPdfHandler(action) {
  const id = action.payload;
  const token = localStorage.getItem('accessToken');
  try {
    const result = yield call(axios, `${config.apiUrl}/core/file/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/octet-stream',
      },
      method: 'GET',
      responseType: 'arraybuffer',
    });
    yield put(requestPdfSuccess(result.data));
  } catch (error) {
    yield put({
      message: error.response,
      type: REQUEST_PDF_FAILED,
    });
  }
}

export default function* fetchSearchWatcher() {
  yield takeEvery(REQUEST_SEARCH_RESULTS, requestSearchResultsHandler);
  yield takeEvery(REQUEST_RUBRIC, requestRubricHandler);
  yield takeEvery(GET_NAUSEARCH_ITEM, getNauSearchItemHandler);
  yield takeEvery(REQUEST_SEARCH_DETAILS_RESULTS, requestSearchDetailsResultsHandler);
  yield takeEvery(REQUEST_PDF, requestPdfHandler);
}
